  import React, { useState } from "react";
  import "./validatepop.scss";
  import { useSelector } from "react-redux";
  import folder from "../../../assets/images/floder-open.png";
  import donecheck from "../../../assets/svg/Action/compltedIcon.svg";
  import error from "../../../assets/svg/Action/Error.svg";
  import dangerwhite from "../../../assets/images/danger-white.png";
  import override from "../../../assets/svg/Action/overridenfinal.svg";
  import { Assetoverride } from "../../../api/api";
  import { toast, ToastContainer } from "react-toastify";
  import "react-toastify/dist/ReactToastify.css";
  import Button from "react-bootstrap/Button";
  import VideoIcon from "../../../assets/svg/Action/viedoIconpop.svg";
  import PosterIcon from "../../../assets/svg/Action/posterIconpop.svg";
  import MetafileIcon from "../../../assets/svg/Action/metafileIconpop.svg";


  function Validatepopup({ validateinfo, handleClosePopup, assetsingledata, permission, onOverrideSuccess }) {
    const [activeView, setActiveView] = useState("grid");
    const [assetinfo, setAssetinfo] = useState(assetsingledata);
    const [filetranscoded, setFileTranscoded] = useState(validateinfo?.transcoded);
    const [postersValidation, setPostersValidation] = useState(validateinfo?.missingPosters || []);
    const [metadataValidation, setMetadataValidation] = useState(validateinfo?.missingMetadataFields || []);
    const [validationStatus, setValidationStatus] = useState(assetsingledata?.validationStatus || "ERROR");
    const missingMetadata = !validateinfo?.missingMetadata;

    const {
      appThemeReducer: { appTheme },
      adminModeReducer: { adminMode },
    } = useSelector((state) => state);

    const overridePoster = async () => {
      try {
        const response = await Assetoverride(assetsingledata.id);
        if (response?.data?.status === true) {
          toast.success("User override successful", {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 5000,
          });
          setValidationStatus("OVERRIDDEN");
          setPostersValidation([]);
          setAssetinfo((prev) => ({
            ...prev,
            validationStatus: "OVERRIDDEN",
            missingPosters: [], 
          }));
          if (onOverrideSuccess) onOverrideSuccess();
        } else {
          console.error("Override failed with response:", response);
          toast.error("Something went wrong, please try again later", {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 5000,
          });
        }
      } catch (error) {
        console.error("Override error:", error);
        toast.error("An error occurred during override", {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 5000,
        });
      }
    };

    return (
      <div className={`content-body ${appTheme === "dark" ? "dark" : "light"}`}>
        <div className="validate">
          <div className="validation-container">
            <div className="validation-text">Validating</div>
            <div className="episode-text">
              Video: <b>{assetinfo?.metadata?.title || assetinfo?.filename}</b>
            </div>
            <div className="file-section">
              <div className="videos-header d-flex justify-content-between">
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div
                    style={{
                      backgroundColor: "#444649",
                      width: "27px",
                      height: "27px",
                      borderRadius: "4px",
                      padding: "7px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: "6px"
                    }}
                  >
                    <img src={VideoIcon} style={{ width: "20px" }} />
                  </div>
                  <span className="videos-label p-2">Videos</span>
                </div>
                <div className="status-icon">
                  <div
                    // className={filetranscoded ? "status-icon-shape success" : "status-icon-shape error"}
                    className={`status-icon-shape ${filetranscoded ? "video-status" : "error"}`}
                  >
                    {filetranscoded ? (
                      <>
                        <img src={donecheck} style={{ height: "20px" }} /> <span>Completed</span>
                      </>
                    ) : (
                      <>
                        <img src={error} style={{ height: "20px" }} />
                        <span>Error</span>
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div className="videos-status">
                <div className="status-text success">
                  {filetranscoded ? "Video is transcoded" : "Video is not transcoded"}
                </div>
              </div>
            </div>
         <hr class="hr hr-blurry" />
            <div className="file-section">
              <div className="videos-header d-flex justify-content-between">
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div
                    style={{
                      backgroundColor: "#444649",
                      width: "27px",
                      height: "27px",
                      borderRadius: "4px",
                      padding: "7px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: "6px"
                    }}
                  >
                    <img src={PosterIcon} style={{ width: "20px" }} />
                  </div>
                  <span className="videos-label p-2">Posters</span>
                </div>
                <div className="status-icon">
                  {/* <div
                    className={
                      validationStatus === "OVERRIDDEN" || postersValidation.length === 0
                        ? "status-icon-shape success"
                        : "status-icon-shape danger"
                    }
                  > */}
                  <div
                    className={`status-icon-shape ${validationStatus === "OVERRIDDEN"
                        ? "posters-overridden-status"
                        : postersValidation.length === 0
                          ? "success"
                          : "danger"
                      }`}
                  >
                    {validationStatus === "OVERRIDDEN" ? (
                      <>
                        <img style={{ height: "20px" }} src={override} />
                        <span>Overridden</span>
                      </>
                    ) : postersValidation.length === 0 ? (
                      <>
                        <img src={donecheck} style={{ height: "20px" }} />
                        <span>Completed</span>
                      </>
                    ) : (
                      <>
                        {permission ? (
                          <a onClick={overridePoster} style={{ cursor: "pointer" }}>
                            <img className="mb-1" src={dangerwhite} /> <span>Override</span>
                          </a>
                        ) : (
                          <a style={{ cursor: "not-allowed" }}>
                            <img className="mb-1" src={dangerwhite} /> <span>Override</span>
                          </a>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
              {/* <div className="videos-status">
                <div className="status-text">
                  <span
                    className={
                      validationStatus !== "OVERRIDDEN" && postersValidation.length !== 0 ? "missing" : "success"
                    }
                  >
                    {validationStatus === "OVERRIDDEN" || postersValidation.length === 0
                      ? "All Posters Are Present"
                      : "Missing:"}
                  </span>
                  {validationStatus !== "OVERRIDDEN" && postersValidation.length !== 0
                    ? postersValidation.map((data, index) => (
                        <React.Fragment key={index}>
                          <span className="ml-2">{data}</span>
                          {index + 1 !== postersValidation.length ? "," : ""}
                        </React.Fragment>
                      ))
                    : null}
                </div>
              </div> */}
              <div className="videos-status">
                <div
                  className={`status-text ${validationStatus === "OVERRIDDEN" || postersValidation.length === 0 ? "success" : ""
                    }`}
                >
                  {validationStatus === "OVERRIDDEN" || postersValidation.length === 0
                    ? "All Posters Are Present"
                    : `Missing: ${postersValidation.join(", ")}`}
                </div>
              </div>
            </div>
      <hr class="hr hr-blurry" />
            <div className="file-section">
              <div className="videos-header d-flex justify-content-between">
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div
                    style={{
                      backgroundColor: "#444649",
                      width: "27px",
                      height: "27px",
                      borderRadius: "4px",
                      padding: "7px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: "6px"
                    }}
                  >
                    <img src={MetafileIcon} style={{ width: "15px" }} />
                  </div>
                  <span className="videos-label p-2">Metadata</span>
                </div>
                <div className="status-icon">
                  <div
                    // className={
                    //   metadataValidation.length === 0 ? "status-icon-shape success" : "status-icon-shape error"
                    // }
                    className={`status-icon-shape ${metadataValidation.length === 0
                        ? "metadata-status-completed"
                        : "metadata-status-error"
                      }`}
                  >
                    {metadataValidation.length === 0 ? (
                      <>
                        <img src={donecheck} style={{ height: "20px" }} /> <span>Completed</span>
                      </>
                    ) : (
                      <>
                        <img src={error} style={{ height: "20px" }} />
                        <span>Error</span>
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div className="videos-status">
                <div
                  className={`status-text ${missingMetadata && metadataValidation.length !== 0 ? "" : "success"}`}
                >
                  {missingMetadata && metadataValidation.length !== 0
                    ? "Missing:"
                    : "All MetaData Are Present"}{" "}
                  {metadataValidation.map((data, index) => (
                    <span key={index} className="mx-2">
                      {data}
                    </span>
                  ))}
                </div>
              </div>
            </div>
            {/* <div className="float-right">
              {validationStatus === "OVERRIDDEN" ? (
                <Button
                  className="Done success-btn"
                  onClick={() => {
                    handleClosePopup();
                    if (onOverrideSuccess) onOverrideSuccess();
                  }}
                >
                  Done
                </Button>
              ) : (
                <Button className="Cancel btn btn-primary" onClick={handleClosePopup}>
                  Cancel
                </Button>
              )}
            </div> */}
            <div className="button-container">


              <Button
                style={{ background: "#333333", border: "1px solid #333333" }}
                onClick={handleClosePopup}
              >
                Cancel
              </Button>
              <Button
                style={{ backgroundColor: '#D22F26', border: "1px solid #D22F26" }}
                onClick={() => {
                  handleClosePopup();
                  if (onOverrideSuccess) onOverrideSuccess();
                }}
              >
                Done
              </Button>
            </div>
          </div>
        </div>
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    );
  }
  export default Validatepopup;